import { Dropdown, Layout, Menu } from 'antd'
import { observer } from 'mobx-react-lite'
import { useRouteMatch } from 'react-router-dom'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next' // Hook để quản lý i18n
import AdminRouters from '../../routes/AdminRouters'
import Sidebar from '../sidebar/Sidebar'
import { useStore } from '../../../hooks'
import { TAB_SIZE } from '../../../helpers/constants'
import SidebarContent from '../sidebar/SidebarContent'
import UserProfile from '../sidebar/UserProfile'
import Images from '../../../common/Images'
import { adminMeta } from '../../routes/metaData'
import IC_EN from 'src/assets/images/ic_eng_flag.svg'
import IC_VN from 'src/assets/images/ic_vn_flag.svg'
import IC_LA from 'src/assets/images/ic_laos_flag.svg'
import IC_CN from 'src/assets/images/ic_cn_flag.svg'

const { Content } = Layout
const { Sider } = Layout

const LayoutAdmin = observer((props: any) => {
   const match = useRouteMatch()
   const AuthStore = useStore('AuthStore')
   const { i18n } = useTranslation() // Lấy i18n từ hook

   // Kiểm tra và đồng bộ ngôn ngữ khi vào màn hình
   useEffect(() => {
      const savedLanguage = localStorage.getItem('language') || 'vi'
      if (i18n.language !== savedLanguage) {
         i18n.changeLanguage(savedLanguage)
      }
      // Nếu cần đồng bộ ngôn ngữ từ localStorage hoặc store, thêm logic ở đây
      // Ví dụ: i18n.changeLanguage(localStorage.getItem('language') || 'vi');
   }, [i18n]) // Thêm i18n vào dependency để theo dõi thay đổi ngôn ngữ nếu cần

   // Hàm thay đổi ngôn ngữ
   const changeLanguage = (lng: string) => {
      i18n.changeLanguage(lng)
      localStorage.setItem('language', lng) // Lưu vào localStorage
   }

   // Menu ngôn ngữ với cờ
   const languageMenu = (
      <Menu>
         <Menu.Item key="en" onClick={() => changeLanguage('en')}>
            <img src={IC_EN} alt="English" style={{ width: 20, marginRight: 8 }} /> English
         </Menu.Item>
         <Menu.Item key="vi" onClick={() => changeLanguage('vi')}>
            <img src={IC_VN} alt="Vietnamese" style={{ width: 20, marginRight: 8 }} /> Tiếng Việt
         </Menu.Item>
         <Menu.Item key="la" onClick={() => changeLanguage('la')}>
            <img src={IC_LA} alt="Laos" style={{ width: 20, marginRight: 8 }} /> Lao
         </Menu.Item>
         <Menu.Item key="cn" onClick={() => changeLanguage('cn')}>
            <img src={IC_CN} alt="Chinese" style={{ width: 20, marginRight: 8 }} /> 中文
         </Menu.Item>
      </Menu>
   )

   const handleOpenSidebar = () => {
      AuthStore.action_openSidebar()
   }

   return (
      <Layout className="gx-app-layout layout-admin">
         <Sider
            className={`gx-app-sidebar gx-layout-sider-dark`}
            trigger={null}
            collapsed={false}
            theme={'dark'}
            collapsible
         >
            {AuthStore.width_screen < TAB_SIZE ? (
               <Sidebar {...props} sideBarContent={adminMeta} />
            ) : (
               <SidebarContent {...props} sidebarCollapsed={true} sideBarContent={adminMeta} />
            )}
         </Sider>
         <Layout>
            <div className="gx-linebar header-mobile-container gx-flex-row gx-justify-content-between overflow-hidden">
               <div>
                  {AuthStore.width_screen < TAB_SIZE && (
                     <i
                        className="gx-icon-btn icon icon-menu"
                        style={{ color: '#535353' }}
                        onClick={handleOpenSidebar}
                     />
                  )}
               </div>
               {AuthStore.width_screen > 400 && (
                  <div className="center-img-content2">
                     {AuthStore.width_screen < TAB_SIZE && (
                        <img src={Images.logo_white} className="img-responsive" alt="Logo" />
                     )}
                  </div>
               )}

               <div className="gx-flex-row gx-align-items-center">
                  {/* {AuthStore.width_screen >= 300 && (
                     <Dropdown overlay={languageMenu} trigger={['click']}>
                        <div className="language-selector" style={{ cursor: 'pointer', marginRight: 16 }}>
                           <img
                              src={
                                 i18n.language === 'en'
                                    ? IC_EN
                                    : i18n.language === 'vi'
                                    ? IC_VN
                                    : i18n.language === 'la'
                                    ? IC_LA
                                    : IC_CN // Mặc định là Tiếng Việt nếu không khớp
                              }
                              alt="Current Language"
                              style={{ width: 28, height: 28, borderRadius: 4, overflow: 'hidden' }}
                           />
                        </div>
                     </Dropdown>
                  )} */}
                  <UserProfile hiddenInfo />
               </div>
            </div>
            <Content className={`gx-layout-content gx-main-content-wrapper`}>
               <AdminRouters match={match} />
            </Content>
         </Layout>
      </Layout>
   )
})

export default LayoutAdmin
